import {ValidationDoc} from "@buildwitt/use-validate";
import {ILessonEntityPayload} from "@buildwitt/shapeshift-types";

export const cohortAnnouncementValidationDoc: ValidationDoc<ILessonEntityPayload> = {
	title: [{
		errorMessage: "required",
		validate: e => !!e.title
	}]
}

